import { movies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import { Link } from 'react-router-dom';

const featuredMovies = movies.filter((m) => m.isHot).slice(0, 8);
const latestMovies = movies.filter((m) => m.isNew).slice(0, 8);
const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function FeaturedSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门推荐</h3>
          <p className="text-sm text-foreground-500 mt-1">精选全网最热影片，不容错过</p>
        </div>
        <Link
          to="/category/dianying"
          className="whitespace-nowrap flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {featuredMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} size="normal" />
        ))}
      </div>
    </section>
  );
}

export function LatestSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新更新</h3>
          <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不断</p>
        </div>
        <Link
          to="/category/dianshiju"
          className="whitespace-nowrap flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {latestMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} size="normal" />
        ))}
      </div>
    </section>
  );
}

export function TopRatedSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">高分佳作</h3>
          <p className="text-sm text-foreground-500 mt-1">口碑爆棚，品质之选</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {topRated.map((movie, index) => (
          <div key={movie.id} className="relative">
            <MovieCard movie={movie} size="normal" />
            <div className="absolute -top-1 -left-1 w-7 h-7 flex items-center justify-center bg-primary-500 text-white text-xs font-bold rounded-full shadow-lg">
              {index + 1}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}